import axios from "axios";
import Swal from "sweetalert2";
import router from '../router/index.js'
const ServerAddress = "https://api.motinova.com:924/api"
//const ServerAddress = "http://localhost:5000"

axios.defaults.timeout = 30000

axios.interceptors.request.use(function (config) {
    config.headers.Authorization = 'Bearer ' + sessionStorage.getItem('userid')
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    console.log(error)
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
}, function (error) {
    if (error.response) {
        if (error.response.status == '401') {
            Swal.fire({
                icon: "error",
                title: "登录过期",
                showConfirmButton: false,
                timer: 1500,
            });
            router.push('/')
        }
    }
    else {
        console.log(error)
        Swal.fire({
            icon: "error",
            title: "网络错误",
            showConfirmButton: false,
            timer: 1500,
        });
    }
    return Promise.reject(error);
});

//登录
const LoginApi = ServerAddress + "/User/Login"

export function login(user, password) {
    return axios.post(LoginApi, {
        userName: user,
        password: password
    })
}

//添加产品类别
const AddProductCatLogApi = ServerAddress + "/ProductCatlog/Insert"

export function AddProductCatlog(name) {
    return axios.post(AddProductCatLogApi, {
        name: name,
    })
}

//获取产品类别
const GetProductCatLogApi = ServerAddress + "/ProductCatlog/GetList"

export function GetProductCatlog(name) {
    return axios.post(GetProductCatLogApi, {
        name: name,
    })
}

//产品类别排序
const SortProductCatLogApi = ServerAddress + "/ProductCatlog/Sort"

export function SortProductCatlog(item) {
    return axios.post(SortProductCatLogApi, item)
}

//产品上传Icon
const UploadProductCatLogIconApi = ServerAddress + "/ProductCatlog/UploadIcon"

export function UploadProductCatlogIcon(item) {
    return axios.post(UploadProductCatLogIconApi, item)
}

//删除产品类别
const DeleteProductCatLogApi = ServerAddress + "/ProductCatlog/DeleteByIds"

export function DeleteProductCatlog(items) {
    return axios.post(DeleteProductCatLogApi, items)
}

//更新产品类别
const UpdateProductCatLogApi = ServerAddress + "/ProductCatlog/Update"

export function UpdateProductCatlog(item) {
    return axios.post(UpdateProductCatLogApi, item)
}

//添加产品
const ADDProductApi = ServerAddress + "/Product/Insert"

export function AddProduct(item) {
    return axios.post(ADDProductApi, item)
}

//获取产品
const GetProductApi = ServerAddress + "/Product/GetList"

export function GetProducts(id) {
    return axios.get(GetProductApi, { params: { catlogid: id } })
}

//获取产品
const GetProductByidApi = ServerAddress + "/Product/GetByID"

export function GetProductByid(id) {
    return axios.post(GetProductByidApi, id)
}

//分页获取产品
const GetProductPageApi = ServerAddress + "/Product/CommonPage"

export function GetProductPages(catlogid, currentPage) {
    return axios.post(GetProductPageApi, null, { params: { catlogid: catlogid, pageIndex: currentPage, pagesize: 50 } })
}

//搜索产品
const SearchProductPageApi = ServerAddress + "/Product/SearchProduct"

export function SearchProductPages(catlogid, currentPage, body, size = 50) {
    return axios({
        method: 'post',
        url: SearchProductPageApi,
        data: body,
        params: { catlogid: catlogid, pageIndex: currentPage, pagesize: size }
    });
}

//删除产品
const DeleteProductApi = ServerAddress + "/Product/DeleteByIds"

export function DeleteProducts(id) {
    return axios.post(DeleteProductApi, [id])
}

//修改产品
const UpdateProductApi = ServerAddress + "/Product/Update"

export function UpdateProduct(item) {
    return axios.post(UpdateProductApi, item)
}

//修改产品
const ChangePriceApi = ServerAddress + "/Product/ChangePrice"

export function ChangePrice(item) {
    return axios.post(ChangePriceApi, item)
}


//获取操作日志
const GetOperateLogAPI = ServerAddress + "/OperateLog/GetList"

export function GetOperateLog() {
    return axios.post(GetOperateLogAPI)
}
//分页获取操作日志
const GetOperateLogPageAPI = ServerAddress + "/OperateLog/CommonPage"

export function GetOperateLogPage(currentPage) {
    return axios.post(GetOperateLogPageAPI, null, { params: { pageIndex: currentPage, pagesize: 100 } })
}

//筛选操作日志
const SearchOperateLogPageAPI = ServerAddress + "/OperateLog/Search"

export function SearchOperateLogPage(currentPage, filter, date) {
    return axios.post(SearchOperateLogPageAPI, date, { params: { pageIndex: currentPage, pagesize: 50, filter: filter } })
}

//获取用户
const GetUsersAPI = ServerAddress + "/User/GetList"

export function GetUser() {
    return axios.post(GetUsersAPI)
}

//增加用户
const AddUsersAPI = ServerAddress + "/User/Insert"

export function AddUser(item) {
    return axios.post(AddUsersAPI, item)
}

//修改用户
const UpdateUsersAPI = ServerAddress + "/User/Update"

export function UpdateUser(item) {
    return axios.post(UpdateUsersAPI, item)
}


//删除用户
const DeleteUsersAPI = ServerAddress + "/User/DeleteByIds"

export function DeleteUser(item) {
    return axios.post(DeleteUsersAPI, item)
}

//获取审批列表
const GetApproveAPI = ServerAddress + "/ApproveItem/CommonPage"

export function GetApproves(currentIndex) {
    return axios.post(GetApproveAPI, currentIndex, {
        headers: { "Content-type": "application/json" },
    })
}

//我的审批列表
const GetMyApproveAPI = ServerAddress + "/ApproveItem/GetMyApproves"

export function GetMyApproves(currentIndex) {
    return axios.post(GetMyApproveAPI, currentIndex, {
        headers: { "Content-type": "application/json" },
    })
}


//通过审批
const PassAPI = ServerAddress + "/ApproveItem/Pass"

export function PassApproves(id) {
    return axios.post(PassAPI, id, {
        headers: { "Content-type": "application/json" },
    })
}

//拒绝审批
const RefuseAPI = ServerAddress + "/ApproveItem/Refuse"

export function RefuseApproves(id) {
    return axios.post(RefuseAPI, id, {
        headers: { "Content-type": "application/json" },
    })
}

//撤回审批
const WithDrawAPI = ServerAddress + "/ApproveItem/DeleteByIds"

export function WithDrawApproves(id) {
    return axios.post(WithDrawAPI, [id])
}

//獲取圖片路徑
const GetImagePathAPI = ServerAddress + "/ImagePath"

export function GetImagePath() {
    return axios.get(GetImagePathAPI)
}

//修改密码
const ChangePasswordAPI = ServerAddress + "/User/ChangePassword"

export function ChangePW(ChangePasswordDto) {
    return axios.post(ChangePasswordAPI, ChangePasswordDto)
}

const ProgressAPI = ServerAddress + "/Process"

//增加进度表条目
export function AddProgressItem(items) {
    return axios.post(ProgressAPI, items)
}

//增加进度表条目
export function UpdateProgressItem(items) {
    return axios.post(ProgressAPI + '/Update', items)
}


//获取进度表
export function GetProgressList() {
    return axios.get(ProgressAPI)
}

//删除进度表
export function DeleteProgress(id) {
    return axios.delete(ProgressAPI + "/" + id)
}

//修改阶段
export function UpdateStepItem(id, item) {
    return axios.post(ProgressAPI + '/UpdateStep?id=' + id, item)
}

//增加新阶段
export function AddNewStep(id, name) {
    return axios.get(ProgressAPI + '/AddNewStep', {
        params: {
            id: id,
            name: name
        }
    })
}

//资料下载
const GetAllFilesAPI = ServerAddress + "/FileModel/GetList"

///获取所有文件
export function GetAllFiles(prefix) {
    return axios.get(GetAllFilesAPI, {
        params: {
            prefix: prefix
        }
    })
}

///上传文件
const UplpadFileAPI = ServerAddress + "/FileModel/Insert"

export function UploadFile(item) {
    return axios.post(UplpadFileAPI, item)
}

///上传修改文件下载权限
const ChangeDownloadStateAPI = ServerAddress + "/FileModel/SetPublic"

export function ChangeDownloadState(item) {
    return axios.get(ChangeDownloadStateAPI, {
        params: {
            id: item
        }
    })
}

///新增文件夹
const AddDirAPI = ServerAddress + "/FileModel/AddDir"

export function AddDir(item) {
    return axios.post(AddDirAPI, item)
}

///删除文件
const DeleteFileAPI = ServerAddress + "/FileModel/DeleteByIds"

export function DeleteFile(item) {
    return axios.post(DeleteFileAPI, [item])
}

///删除文件
const RenameFileAPI = ServerAddress + "/FileModel/reame"

export function RenameFile(item, newName) {

    const formData = new FormData();
    formData.append('id', item.id);
    formData.append('newName', newName); // 假设 fileInputElement 是一个文件输入元素

    // 使用 axios 发送 FormData
    const response = axios.post(RenameFileAPI, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })


    return response;
}

///请求下载
const RequestDownloadApi = ServerAddress + "/FileModel/RequsetDownload"

export function RequestDownload(item) {
    return axios.get(RequestDownloadApi, { params: { id: item } })
}

///下载记录
const SendDownloadLogApi = ServerAddress + "/FileModel/Downloadlog"

export function SendDownloadLog(item) {
    return axios.get(SendDownloadLogApi, { params: { id: item } })
}

const GetAllModelsApi = ServerAddress + '/product/getallmodel';
//获取所有型号
export function GetAllProductModels() {
    return axios.get(GetAllModelsApi)
}

//获取故障码维护措施
const GetMeasureAPI = "https://webapi.motinova.com/api/troubleshooting/language/";

export function GetMeasure(shootingOne) {

    return axios.get(GetMeasureAPI + shootingOne)
}

//生成Docx文档
const GetDocxApi = ServerAddress + '/DocxGenerate/GetDocx';
//获取所有型号
export function GetDocx(keyvaluedata) {
    return axios.post(GetDocxApi, keyvaluedata, { responseType: 'blob' })
}
